import { InquiryFormInterface } from '../InquiryForm';

interface Errors {
    email?: string;
    first_name?: string;
    last_name?: string;
    message?: string;
    phone_number?: string;
    guest_count?: string;
    date?: null | string;
    checkbox?: boolean;
}

const inquiryValidator = (values: InquiryFormInterface) => {
    const errors: Errors = {};
    if (!values.first_name) {
        errors.first_name = 'First name is required!';
    }
    if (!values.last_name) {
        errors.last_name = 'Last name is required!';
    }
    if (!values.message) {
        errors.message = 'Message is required!';
    }

    if (!values.email) {
        errors.email = 'Email is required!';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = 'Please enter a valid email address';
    }

    if (!values.phone_number) {
        errors.phone_number = 'Phone number is required!';
    } else if (!/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/i.test(values.phone_number)) {
        errors.phone_number = 'Please enter a valid phone number';
    }

    const guest_count = parseInt(values.guest_count, 10);
    if (guest_count !== 0 && !values.guest_count) {
        errors.guest_count = 'Guest count is required!';
    } else if (guest_count < 0 || guest_count > 10000) {
        errors.guest_count = 'Wrong count of guests';
    }

    if (!values.date && !values.checkbox) {
        errors.date = "Please specify your preferred wedding date or check 'My dates are flexible'";
    }

    return errors;
};

export default inquiryValidator;
